import {apolloClient} from '@/setup/apollo-setup';
import {error, newItemSuccess, updateItemSuccess, deleteItemSuccess} from '@/utils/notification';
import {
  GET_CURRICULUM,
  GET_CURRICULA,
  ADD_CURRICULUM,
  UPDATE_CURRICULUM,
  DELETE_CURRICULUM
} from '@/queries/modules/common-data/curriculum';

export async function getCurricula(context) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_CURRICULA,
        fetchPolicy: 'network-only'
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setCurricula', data.getCurricula);
      context.commit('setSuccess', null);
      return data.getCurricula
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getCurriculum(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_CURRICULUM,
        variables: payload
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setCurriculum', data.getCurriculum);
      context.commit('setSuccess', null);
      return data.getCurriculum
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function addCurriculum(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: ADD_CURRICULUM,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const curricula = [...context.state.curricula];
      curricula.push(data.addCurriculum);
      context.commit('setCurricula', curricula);
      context.commit('setSuccess', newItemSuccess(data.addCurriculum.nameLocal));

      return data.addCurriculum
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function updateCurriculum(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: UPDATE_CURRICULUM,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {

      const index = context.state.curricula.findIndex(item => item.id === data.updateCurriculum.id);
      const curricula = [
        ...context.state.curricula.slice(0, index),
        data.updateCurriculum,
        ...context.state.curricula.slice(index + 1)
      ];
      context.commit('setCurricula', curricula);
      context.commit('setSuccess', updateItemSuccess(data.updateCurriculum.nameLocal));

      return data.updateCurriculum
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function deleteCurriculum(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: DELETE_CURRICULUM,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const index = context.state.curricula.findIndex(item => item.id === data.deleteCurriculum.id);
      const curricula = [
        ...context.state.curricula.slice(0, index),
        ...context.state.curricula.slice(index + 1)
      ];
      context.commit('setCurricula', curricula);
      context.commit('setSuccess', deleteItemSuccess(data.deleteCurriculum.nameLocal));

      return data.deleteCurriculum
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

